<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <title-comp/>
      </v-col>
    </v-row>
    <v-row class="ml-n8 mr-n8">
      <v-col cols="12">
        <v-data-table
          v-if="!(matchingContacts!=null && matchingContacts.length==0 && totalFound>0)"
          :headers="headers"
          @click:row="onRowClicked"
          :items="preparedContacts">
        </v-data-table>
        <h2 v-else><br>Too many results:<br>{{totalFound}} contacts found (>100)</h2>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-dialog v-model="appevent.openSearchMenu" transition="dialog-top-transition" width="100%" height="100vh" persistent>
          <v-card width="Auto">
            <v-form validate-on="submit lazy" @submit.prevent="runSearch" style="border-top:1px solid gray;">
              <v-text-field
                prepend-inner-icon="mdi-text-box-outline"
                v-model="filter.FirstNameLastName"
                clearable
                label="Nom et/ou Prénom"/>

              <StatesSelector
                        label="Cust. state(s)"
                        :items="refstore.CustomerStates"
                        v-model="filter.SelectedCustStates"
                        multiple/>

              <EntityAutocomplete
                        label="Accounts"
                        v-model="filter.SelectedEntities"
                        :onSearch="onSearchEntity"
                        prepend-inner-icon="mdi-office-building"
                        multiple/>

              <ContactAutocomplete
                        label="Sales superv."
                        v-model="filter.SelectedSales"
                        :onSearch="onSearchSalesSuperv"
                        prepend-inner-icon="mdi-handball"
                        multiple/>
            </v-form>

            <template v-slot:actions>
              <v-btn class="ms-auto" text="&#x1F9F9; Vider" @click="cleanFilter"/>
              <v-btn class="ms-auto" text="&#128269; Chercher" @click="runSearch"/>
              <v-btn class="ms-auto" text="&#10060; Fermer" @click="closeSearch"/>
            </template>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-dialog v-model="openRowDetail" transition="dialog-top-transition" width="100%" height="100vh" persistent>
          <v-card width="Auto">
            <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <div class="section_main_title">{{ viewContact.firstName }}&nbsp;{{ viewContact.lastName }}</div>
                <div class="section_title">&#x2022; STATUS INFOS</div>
                <div class="section_content" v-if="viewContact.lastCustomerActivity==null">
                  <i>No last activity</i>
                </div>
                <div  class="section_content">
                  <div><b>State:&nbsp;</b><i>{{ viewContact.customerState }}</i></div>
                  <activity-infos :activity="viewContact.lastCustomerActivity"></activity-infos>
                  <div>
                    <span>&#x1F4DE;: <a :href="'tel:' + viewContact.phone">{{ viewContact.phone }}</a></span> |
                    <span>&#x2709;: <a :href="'mailto:' + viewContact.email">{{ viewContact.email }}</a></span>
                  </div>
                </div>
                <hr>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <div style="padding-top: 1vh;"></div>
                <div class="section_title">&#x2022; POSITION</div>
                <div class="section_content" v-if="viewContact.lastCustomerPosition==null">
                  <i>No position found</i>
                </div>
                <div class="section_content" v-if="viewContact.lastCustomerPosition">
                  <PositionInfos :position="viewContact.lastCustomerPosition"/>

                  <div style="color: #777777;">
                    <div><b>Sales:&nbsp;</b><i>{{ viewContact?.salesSupervisor?.firstName }}&nbsp;{{ viewContact?.salesSupervisor?.lastName }}</i></div>
                  </div>
                </div>
                <hr>
              </v-col>
            </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <div style="padding-top: 1vh;"></div>
                  <div class="section_title">&#x2022; DOCUMENTS</div>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5"/>
                <v-col cols="2">
                  <Spinner style="text-align: center;" v-if="docList == null"/>
                </v-col>
                <v-col cols="5"/>
              </v-row>
              <template v-if="docList != null && filteredDocList.length>0">
                <v-row @click="downloadDocument(d.docId)" no-gutters v-for="d in filteredDocList" :key="d.docId" class="liste-doc-class section_content">
                  <v-col cols="12" style="padding-top: 1%; padding-bottom: 1%;">
                    <p>&#x1F441;</p> [{{d.date}}] {{d.name}}
                  </v-col>
                </v-row>
              </template>
              <template v-if="docList != null && filteredDocList.length==0">
                  <div style="font-family: aldrich; border-top: 1px solid black; padding-top: 2%;">Aucun document trouvé &#x1f63f;</div>
              </template>
            </v-container>
            <hr>
            <template v-slot:actions>
              <v-btn class="ms-auto" text="&#10060; Fermer" @click="openRowDetail=false"/>
            </template>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ContactFilteringCategoryEnum from '@/utils/ContactFilteringCategoryEnum.js'
import TitleComp from '@/components/TitleComp.vue'
import PositionInfos from '@/components/PositionInfos.vue'
import ActivityInfos from '@/components/ActivityInfos.vue'
import StatesSelector from '@/components/StatesSelector.vue'
import { AppEventsStore, ReferentialStore } from '@/stores'
import { DatabaseServiceInstance } from '@/database'
import { LynxUtils } from '@/utils'
import { ContactSvcInstance, DocSvcInstance, EntSvcInstance } from '@/lynxapi'
import Spinner from '@/components/Spinner.vue'
import ContactAutocomplete from '@/components/ContactAutocomplete.vue'
import EntityAutocomplete from '@/components/EntityAutoComplete.vue'
import '@/assets/viewdetailstyles.css'

const moment = require('moment')

export default {
  components: {
    TitleComp,
    Spinner,
    PositionInfos,
    StatesSelector,
    ActivityInfos,
    ContactAutocomplete,
    EntityAutocomplete
  },
  computed: {
    appevent: function () {
      return AppEventsStore()
    },
    refstore: function () {
      return ReferentialStore()
    },
    utils: function () {
      return LynxUtils
    },
    preparedContacts: function () {
      return this.matchingContacts.map(contact => ({
        ...contact,
        fullName: `${contact.firstName} ${contact.lastName}`
      }))
    },
    filteredDocList: function () {
      if (!this.docList) {
        return []
      }

      // Filtrer pour ne garder que les éléments contenant "cv" dans name, indépendamment de la casse
      const filteredList = this.docList.filter(item => item.name.toLowerCase().includes(''))

      // Trouver l'élément avec la date la plus récente
      const mostRecent = filteredList.reduce((latest, item) => {
        return (moment(latest.date, 'DD/MM/YYYY') > moment(item.date, 'DD/MM/YYYY')) ? latest : item
      }, filteredList[0]) // Initialise avec le premier élément du tableau filtré
      if (mostRecent) {
        return [mostRecent]
      }
      return []
    }
  },
  data: () => ({
    filter: {
      FirstNameLastName: '',
      SelectedCustStates: [],
      SelectedSales: [],
      SelectedEntities: []
    },
    foundSalesSuperv: [],
    foundEntities: [],
    matchingContacts: [],
    totalFound: 0,
    openRowDetail: false,
    viewContact: null,
    docList: null,
    headers: [
      {
        title: 'Name',
        align: 'start',
        sortable: true,
        key: 'fullName'
      },
      {
        title: 'Account',
        align: 'start',
        sortable: true,
        key: 'lastCustomerPosition.entityName'
      },
      { title: 'Profile', key: 'lastCustomerPosition.profile' },
      { title: 'Job', key: 'lastCustomerPosition.job' }
    ]
  }),
  methods: {
    async onRowClicked (event, item) {
      this.openRowDetail = true
      this.viewContact = item.item
      this.docList = null
      this.docList = await DocSvcInstance.findDocumentsForContact(this.viewContact.contactId)
    },
    async downloadDocument (docId) {
      await DocSvcInstance.downloadDocument(docId)
    },
    runSearch: async function () {
      DatabaseServiceInstance.saveFilter('cust', this.filter)
      const res = await ContactSvcInstance.findMatchingCustomers(this.filter)
      this.matchingContacts = res?.result
      this.totalFound = res?.count
      this.closeSearch()
    },
    closeSearch: function () {
      this.appevent.openSearchMenu = false
    },
    cleanFilter: function () {
      this.filter = {}
    },
    onSearchSalesSuperv: async function (searchInput) {
      return await ContactSvcInstance.autocompleteContact(searchInput, ContactFilteringCategoryEnum.SALES, true)
    },
    onSearchEntity: async function (searchInput) {
      return await EntSvcInstance.autocompleteEntity(searchInput)
    },
    closeDropdown: function (truc) {
      // Accède à la référence de v-autocomplete et déclenche la méthode blur pour fermer le menu
      this.$refs.autocomplete2.blur()
    }
  },
  async mounted () {
    this.filter = await DatabaseServiceInstance.loadFilter('cust')
  },
  watch: {
    'appevent.openSearchMenu': async function (newval, oldval) {
      if (newval === true) {
        this.filter = await DatabaseServiceInstance.loadFilter('cust')
      }
    }
  }
}
</script>
